import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './SampleInfo.css';

import { useMtg } from '../../hook/useMtg';
import { useSample } from '../../hook/useSample';
import { buildClass } from '../../libs/classes';
import { cardFinishText } from '../../hoc/MtgProvider';
import ConfirmModal from '../Modals/ConfirmModal/ConfirmModal';
import MoveSamplesModal from '../Modals/MoveSamplesModal/MoveSamplesModal';
import SimpleButton, { ButtonsWrapper, ButtonTypes } from '../SimpleComponents/SimpleButton';

/**
 * Represent sample information
 * @component
 */
const SampleInfo = ({ sample, isOwned, onStartEdit, onDelete, onMove }) => {
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showMoveModal, setShowMoveModal] = useState(false);
	const [samplesObj, setSamplesObj] = useState({});

	const { deleteSample } = useSample();
	const { getShortCondition, getFullCondition } = useMtg();

	useEffect(() => {
		console.log('Initialization: SampleInfo');
	}, []);

	useEffect(() => {
		let samplesObjUpd = {};
		samplesObjUpd[sample.id] = sample;
		setSamplesObj(samplesObjUpd);
	}, [sample]);

	return (
		<div className="sample-info">
			<div className="quantity">
				<span className="qty">{sample.qty}</span>&thinsp;×&thinsp;
				<span className={buildClass('finish').add(sample.finish, `finish-${sample.finish}`)}>
					{sample.finish in cardFinishText ? cardFinishText[sample.finish] : '?'}
				</span>
				&nbsp;
				<span className="language">({sample.language})</span>
			</div>
			<div className="condition" title="Card condition">
				<div className="content">
					<span className={buildClass('state', getShortCondition(sample))}>{getShortCondition(sample)}</span>
					<span className="full">{getFullCondition(sample)}</span>
				</div>
			</div>
			{sample.note ? <div className="note">Note: {sample.note}</div> : null}
			{isOwned ? (
				<>
					<div className="spacer" />
					<ButtonsWrapper>
						<SimpleButton title="Change" type={ButtonTypes.DEFAULT} value="Change" onClick={handleEdit} />
						<SimpleButton title="Move" type={ButtonTypes.DEFAULT} value="Move" onClick={openMoveDialog} />
						<div className="spacer" />
						<SimpleButton
							title="Delete"
							type={ButtonTypes.RED}
							value="Delete"
							onClick={openDeleteConfirmDialog}
						/>
					</ButtonsWrapper>
				</>
			) : null}

			<ConfirmModal
				defaultYes={true}
				isOpen={showDeleteModal}
				title="Delete sample"
				onResult={handleDeleteSample}
			>
				Are you sure you want to delete this sample?
			</ConfirmModal>

			<MoveSamplesModal
				isOpen={showMoveModal}
				samples={samplesObj}
				onCancel={handleCloseMoveDialog}
				onConfirm={onMove}
			/>
		</div>
	);

	function handleEdit() {
		onStartEdit();
	}
	function openMoveDialog() {
		setShowMoveModal(true);
	}
	function handleCloseMoveDialog() {
		setShowMoveModal(false);
	}
	function openDeleteConfirmDialog() {
		setShowDeleteModal(true);
	}
	function handleDeleteSample(result) {
		setShowDeleteModal(false);
		if (result) {
			if (sample) {
				deleteSample(sample.id, (status) => {
					onDelete(status);
				});
			}
		}
	}
};

SampleInfo.propTypes = {
	// Sample object
	sample: PropTypes.object.isRequired,
	// Is this sample owned by current user
	isOwned: PropTypes.bool.isRequired,
	// Callback function on edit request
	onStartEdit: PropTypes.func.isRequired,
	// Callback function after deletion
	onDelete: PropTypes.func.isRequired,
	// Callback function after move
	onMove: PropTypes.func.isRequired,
};

export default SampleInfo;
